export default __webpack_public_path__ + "static/media/list-first.2d3a602b.svg";